<template>
  <div :class="[`form_${widget.id}`, { active: isActive(widget.id) }]" :style="style">
    <div v-html="`<style>${options.style.css}</style>`"></div>
    <div :class="widget.id">
      <FormItem v-for="item in options.items" :key="item.id" :item="item" :itemStyle="options.itemStyle" />
    </div>
  </div>
</template>

<script>
import FormItem from './form/FormItem'
import { mapGetters } from 'vuex'
import WidgetMixin from './Mixin.js'

export default {
  name: 'CaptureFormWidget',
  mixins: [WidgetMixin],
  components: { FormItem },
  computed: {
    ...mapGetters('landing', ['isActive']),
    style() {
      return {
        background: `${this.options.backgroundColor}`,
        paddingTop: `${this.options.padding.top}px`,
        paddingRight: `${this.options.padding.right}px`,
        paddingBottom: `${this.options.padding.bottom}px`,
        paddingLeft: `${this.options.padding.left}px`,
        borderColor: this.options.border.color,
        borderWidth: `${this.options.border.width}px`,
        borderRadius: `${this.options.border.radius}px`,
        borderStyle: this.options.border.style,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
[class^='form_'] {
  > div {
    display: flex;
    flex-wrap: wrap;
  }
  &.active > div {
    box-shadow: 0 0 0 1px green, inset 0 0 0 1px green;
    > [class^='item-form_'] {
      box-shadow: 0 0 0 1px lime, inset 0 0 0 1px lime;
    }
  }
  .required {
    position: absolute;
    bottom: 0;
  }
}
</style>
